import { PositiveColors } from '@picsart/design-system/foundation/colors';

import { createUseStyles } from 'react-jss';

import { Spacings } from '@picsart/design-system/foundation/spacings';
import { BreakPointsMedia } from '@picsart/design-system/foundation/responsive';

const useTemplateStyles = createUseStyles(
  {
    popupButton: {},
    shareSliderWrapper: {
      display: 'flex',
      padding: Spacings.s10,
      justifyContent: 'center',
      backgroundColor: PositiveColors.base.default,
      borderRadius: Spacings.s24,
      alignItems: 'center',
      width: Spacings.s32,
      height: Spacings.s32,
      margin: 0,
      '&:hover': {
        cursor: 'pointer',
      },
      [BreakPointsMedia.MD]: {
        display: 'none',
      },
      [BreakPointsMedia.SM]: {
        display: 'none',
      },
      [BreakPointsMedia.XS]: {
        display: 'none',
      },
      [BreakPointsMedia.XXS]: {
        display: 'none',
      },
    },
    asideShareSliderWrapper: {
      display: 'flex',
      padding: Spacings.s12,
      justifyContent: 'center',
      backgroundColor: PositiveColors.base.default,
      borderRadius: Spacings.s24,
      alignItems: 'center',
      width: Spacings.s48,
      height: Spacings.s48,
      margin: 0,
      '&:hover': {
        cursor: 'pointer',
      },
      [BreakPointsMedia.MD]: {
        width: Spacings.s44,
        height: Spacings.s44,
      },
      [BreakPointsMedia.SM]: {
        width: Spacings.s44,
        height: Spacings.s44,
      },
      [BreakPointsMedia.XS]: {
        width: Spacings.s44,
        height: Spacings.s44,
      },
      [BreakPointsMedia.XXS]: {
        width: Spacings.s44,
        height: Spacings.s44,
      },
    },
    shareButtons: {
      width: 300,
    },
  },
  {
    name: 'share-button',
  },
);

export default useTemplateStyles;
